// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Ov-z","tooltipWrapper":"Pv-z","icon":"Qv-z","tooltip":"Rv-z","content":"Sv-z"};